<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <form @submit="onSubmit">
            <div class="row">
                <b-col cols="12" sm="6" class="mb-3">
                  <b-form-group
                    label="Nombres"
                  >
                    <b-form-input
                      v-model="user.name"
                      type="text"
                      placeholder="Nombres completos"
                      :state="validate(user.name)"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" class="mb-3">
                  <b-form-group
                    label="Apellidos"
                  >
                    <b-form-input
                      v-model="user.lastName"
                      type="text"
                      placeholder="Apellidos completos"
                      :state="validate(user.lastName)"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" class="mb-3">
                  <b-form-group
                    label="Correo"
                  >
                    <b-form-input
                      v-model="user.mail"
                      type="email"
                      placeholder="Correo"
                      :state="validate(user.mail)"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" class="mb-3">
                  <b-form-group
                    label="Confirmar correo"
                  >
                    <b-form-input
                      v-model="user.mailConfirmar"
                      type="email"
                      placeholder="Repita el correo"
                      :state="validate(user.mailConfirmar)"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                
                <div class="col-12 col-sm-6 mb-3">
                    <PasswordInput
                        v-model="user.password"
                        label="Contraseña"
                        :state="validate(user.password)">
                    </PasswordInput>
                </div>

                <div class="col-12 col-sm-6 mb-3">
                    <PasswordInput
                        v-model="user.passwordConfirmar"
                        label="Confirmar contraseña"
                        :state="validate(user.passwordConfirmar)">
                    </PasswordInput>
                </div>

                <div class="col-12 col-sm-6 mb-3">
                    <RutInput v-model="user.rut" :state="validate(user.rut)"/>
                </div>

                <div class="col-12 col-sm-6 mb-3">
                    <div>
                        <label for="listaRolesFormControlInput" class="form-label">Rol</label>
                        <b-form-select id="listaRolesFormControlInput" class="form-select" v-model="roleSelected"
                            :options="roles"
                            :state="validate(roleSelected)">
                            <template #first>
                                <option value="" disabled>-- Selecciona un rol --</option>
                            </template>
                        </b-form-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-6">
                    <button type="submit" class="btn btn-outline-primary" :disabled="process">
                        <b-spinner v-if="process" small></b-spinner>
                        Crear
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import RutInput from '@/components/shared/RUT-input.vue'
import PasswordInput from '@/components/shared/Password-input.vue'
import { validateNonEmpty } from '@/plugins/complianceScripts';

export default {
    name: 'UserForm',

    data() {
        return {
            roleSelected: '',
            roles: [],
            user: {
                name: '',
                lastName: '',
                mail: '',
                mailConfirmar: '',
                password: '',
                passwordConfirmar: '',
                rut: ''
            },

            attemptedSubmit: false, 

            process: false,
        }
    },

    computed: {
        allValuesFilled() {
            return Object.values(this.user).every(x => x != '')
        }
    },
    components: {
        AlertDismiss,
        RutInput,
        PasswordInput
    },

    async mounted() {
        this.getRoles();
    },

    methods: {
        ...mapActions(["allRoles", "createUser"]),

        validate(value) {
            return validateNonEmpty(value, this.attemptedSubmit);
        },

        async onSubmit(event) {
            event.preventDefault();

            this.attemptedSubmit = true
            if (!this.allValuesFilled) {
                this.$refs.alertDismiss.showAlert('Debe completar todos los campos', 'warning');
                return
            }
            this.attemptedSubmit = false
            
            this.processing();

            if (this.user.mail != this.user.mailConfirmar) {
                this.$refs.alertDismiss.showAlert('La confirmación del correo no es correcta');
                this.processing();
                return;
            }
            else if (this.user.password != this.user.passwordConfirmar) {
                this.$refs.alertDismiss.showAlert('La confirmación de la contraseña no es correcta');
                this.processing();
                return;
            }

            let result = await this.createUser({
                name: this.user.name,
                lastName: this.user.lastName,
                mail: this.user.mail,
                password: this.user.password,
                roleId: this.roleSelected,
                rut: this.user.rut
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.processing();
                return;
            }

            this.clearForm();

            this.processing();

            this.$eventBus.$emit(EventNames.CreateUser, {
                mail: this.user.mail, 
                page: 1, 
                pageSize: InitPageSize.UsersPageSize});
        },

        async getRoles() {
            let result = await this.allRoles();

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            let data = result.data.map((role) => {
                return {
                    value: role.id,
                    text: role.name
                }
            });

            this.roles = data;
        },

        clearForm() {
            this.user.name = '';
            this.user.lastName = '';
            this.user.mail = '';
            this.user.mailConfirmar = '';
            this.user.password = '';
            this.user.passwordConfirmar = '';

            this.getRoles();
        },

        processing() {
            this.process = !this.process;
        },
    }
}
</script>
